export default __webpack_public_path__ + "static/media/mansion-home.93eb3901.JPG";